import React from 'react'
import {makeStyles, IconButton} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close';
import {SnackbarProvider, useSnackbar} from 'notistack'
import GlobalSnackbar from 'components/containers/GlobalSnackBar'

const useStyles = makeStyles(({palette}) => ({
  // default variant
  variantSuccess: {
    backgroundColor: palette.success.main,
  },
  variantError: {
    backgroundColor: palette.error.main,
  },
  variantInfo: {
    backgroundColor: palette.info.main,
  },
  variantWarning: {
    backgroundColor: palette.warning.main,
    color: palette.warning.contrastText,
  }
}))

const  SnackbarCloseButton = ({ snackbarKey }) =>{
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton onClick={() => closeSnackbar(snackbarKey)}>
      <CloseIcon style={{ color: 'white' }} />
    </IconButton>
  );
}

const NotistackProvider = ({children}) => {
  const classes = useStyles()
  return (
    <SnackbarProvider  
    action={snackbarKey => <SnackbarCloseButton snackbarKey={snackbarKey} />}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
     classes={classes}>
      <GlobalSnackbar />
      {children}
    </SnackbarProvider>
  )
}

export default NotistackProvider
